//libs
import {useEffect, useState} from 'react';
import axios from 'axios';
//additional
import PageTemplate from './components/pageTemplate';
import {system} from 'services/objects';
import {useQuery} from 'components/useQuery';

const {
  CONFIG_PARAMS: {CUSTOM_PAGE, APPLICATION, LOGIN_PAGE},
  PAGES: {LOGIN, RESTORE_PASSWORD: RESTORE_PASSWORD_PAGE},
} = system;

const SignUser = ({userConfig, showNotification}) => {
  const query = useQuery();
  const [loaded, setLoaded] = useState(false);
  const [activePage, setActivePage] = useState(LOGIN);
  const [rightPanelActiveToggle, setRightPanelActiveToggle] = useState(false);
  const code = query.get('code');

  const loginPage = (() => {
    try {
      return userConfig[APPLICATION][LOGIN_PAGE];
    } catch {}
    return {};
  })();

  const customPage = loginPage[CUSTOM_PAGE];

  useEffect(() => {
    if (activePage === LOGIN) {
      setRightPanelActiveToggle(false);
    }
  }, [activePage]);

  useEffect(() => {
    if (Boolean(code)) {
      setActivePage(RESTORE_PASSWORD_PAGE);
      setRightPanelActiveToggle(true);
    }
  }, [code]);

  const toggleSignInUp = e => {
    e.preventDefault();
    setRightPanelActiveToggle(!rightPanelActiveToggle);
  };

  /**
   * get custom login page URL from user config
   * @type {string | null}*/
  useEffect(() => {
    const url = customPage ? customPage : null;
    if (url) {
      axios
        .get(url)
        .then(() => {
          window.location.href = url;
        })
        .catch(() => {
          setLoaded(true);
        });
    }
    setLoaded(true);
  }, [customPage]);

  if (!loaded) return null;

  return (
    <PageTemplate
      activationCode={code}
      loginPage={loginPage}
      setActivePage={setActivePage}
      activePage={activePage}
      rightPanelActiveToggle={rightPanelActiveToggle}
      toggleSignInUp={toggleSignInUp}
      showNotification={showNotification}
    />
  );
};

export default SignUser;
